import Api from '@/services/Api'

export default {
    getAllCentroCostos(){
        return Api().get('centroCostos/getAll')
    },
    getCentroCostosById(id){
        return Api().get('/centroCostos/getCentroCostoById/'+id)
    },
    createCentroCostos(datos){
        return Api().post('/centroCostos/create',datos)
    },
    updateCentroCostosById(datos){
        return Api().put('/centroCostos/update',datos)
    },
    deleteCentroCostos(id){
        return Api().delete('/centroCostos/delete/'+id)
    }
}